import React from 'react'

import LoadingWidget from '@/components/widgets/LoadingWidget'

const LoadingScreen: React.FC = () => (
  <div className="flex h-full items-center justify-center">
    <LoadingWidget />
  </div>
)

export default LoadingScreen
